import { ViewHeader } from '@enkla-gui'

import PremadeReports from '../../components/report/PremadeReports'
import React from 'react'
import { icons } from '@config'
import { useHistory } from 'react-router-dom'

export default function PremadeReportsView() {
	const history = useHistory()

	const handleLoadReport = (reportConfig) => {
		// Store the config in sessionStorage since hash routing doesn't support state
		sessionStorage.setItem('premadeReportConfig', JSON.stringify(reportConfig))

		// Navigate to the custom report page
		history.push('/report/create')
	}

	return (
		<>
			<ViewHeader
				title='Fördefinierade Rapporter'
				icon={icons.star}
				subtitle='Välj en färdig rapportmall'
			/>
			<PremadeReports onLoadReport={handleLoadReport} />
		</>
	)
}
